<template>
  <b-row class="right" style="background: #f3f2f2">
    <h5 style="color: #0092de; font-size: 1.2rem">{{ title }}</h5>
    <ul>
      <li
        :class="[
          version == 'forum' ? 'right-item-forum' : 'right-item-science',
        ]"
        v-for="(item, index) in dataList"
        :key="index"
        style="display: flex; align-items: center"
      >
        <div
          class="img-wrap img-hovor"
          style="
            padding-right: 1rem;
            flex: 1.05 1 0%;
            height: 5.8rem;
            border-radius: 0px;
          "
        >
          <img
            @click="toLink(item.id, item.categoryId)"
            width="100%"
            height="100%"
            :src="item.titleImg"
          />
        </div>

        <div style="flex: 2">
          <div
            class="text-left"
            style="color: #666666; margin: 0rem 0rem 1rem 0rem"
          >
            {{ item.title }}​
          </div>

          <div class="text-left" style="color: #b0b0b0; display: inline-block">
            {{ item.categoryName }}
          </div>
          <div
            class="text-right"
            style="color: #b0b0b0; display: inline-block; float: right"
          >
            {{ item.createTime }}
          </div>
        </div>
      </li>
    </ul>
  </b-row>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "notice",
    },
    date: {
      type: String,
      default: "2021-6-16",
    },
    version: {
      type: String,
      default: "science",
    },
    dataList: {
      type: Array,
      default: () => [{}],
    },
    title: {
      type: String,
      default: "相关阅读",
    },
  },
  data() {
    return {};
  },
  inject: ["reload"],
  methods: {
    toLink(id, categoryId) {
      this.reload(); ///forum/project/detail?id=${item.id}&categoryId=${item.categoryId}
      this.$router.push({
        path: `/forum/project/detail?id=${id}&categoryId=${categoryId}`,
        query: {
          mode: "activity",
          categoryId: categoryId,
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.right {
  // padding: 2rem!important;
  width: 30rem;
  margin-top: 3.5rem;
  padding: 2rem;
  a:hover {
    color: #666666 !important;
  }

  .tit-science {
    font-weight: 100 !important;
    color: $science-theme-color;
  }

  .tit-forum {
    font-weight: 100 !important;
    color: $forum-theme-blue;
  }

  .right-item-science {
    font-size: 1rem;
    color: #666666;
    line-height: 1.8rem;
    padding: 0.2rem;
    border-bottom: 0.1rem solid #ebebeb;
  }

  .img-wrap {
    margin: 1rem 0 !important;
  }

  .right-item-science:hover {
    color: $science-theme-color;
    cursor: pointer;
  }

  .right-item-forum {
    font-size: 1rem;
    color: #666666;
  }

  .right-item-forum:hover {
    color: $forum-theme-blue;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
  .right {
    margin: 0;
    width: 26rem;
  }
}
</style>